import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[clickOut]'
})
export class ClickOutDirective {

    constructor(private elementRef: ElementRef) { }

    @Output() outside: EventEmitter<boolean> = new EventEmitter();

    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent) {
        if (!event.target) return;

        const clickedInside = this.elementRef.nativeElement.contains(event.target);

        if (!clickedInside) {
            setTimeout(() => this.outside.emit(true), 0);
        }
    }

}
